<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
    <!-- 订单详情 -->
    <template #ORDERDETAIL="{ params, visible }">
      <order
        v-if="visible"
        :orderDetails="params.dataDetails"
        :pageText="params.pageText"
        :footer-hide="false"
      ></order>
    </template>
  </cTable>
</template>

<script>
import { getAllClient } from "@/api/user/client";
import { getOrderDetails } from "@/api/order/list";
import { getOtherOrder, updateSheet } from "@/api/order/other";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";

import Tracker from "@/base/order_tracker";
import { proxyErr, pushProxy, saveProxy } from "@/api/order/proxy";
import order from "_c/order-details";
import cTable from "@/base/common/index";
export default {
  props: {
    type: {
      type: Number,
      default: 3,
    },
  },
  name: "goods",
  components: {
    cTable,
    Tracker,
    order,
  },
  async mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "clientId")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "serviceId")
        item.options = (
          await getUser({ standard: "DblCustomerService" })
        ).data.payload.rows;
      if (item.key === "salesmanId")
        item.options = (
          await getUser({ standard: "Salesman" })
        ).data.payload.rows;
      if (item.key === "to_country")
        item.options = (await getCountry()).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: (p) => {
          p["type"] = this.type;
          return getOtherOrder(p);
        },
        getAllClient,
        updateSheet,
        getOrderDetails,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {
        upload: {
          footer: {
            ok: {
              name: "上传",
            },
            cancel: {},
          },
          methods: {
            ok: ({ list }) => {
              this.$refs["table"].getModal("upload").disabledConfirm = true;
              let data = new FormData();
              for (var i = 0; i < list.length; i++) {
                data.append("file[]", list[i].file); // 文件对象
              }
              data.append("type", this.type);
              this.$refs["table"]
                .handleRequestMethods("updateSheet", data, true)
                .then((res) => {
                  this.$refs["table"].getModal(
                    "upload"
                  ).disabledConfirm = false;
                  this.$refs["table"].getModal("upload").list = res.payload;
                  // this.$page.getList();
                  // this.close();
                });
            },
            cancel() {
              // console.log("1123");
              this.$page.getList();
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              maskClosable: false,
            },
            modalContentBind: {
              style: {
                height: "500px",
              },
            },
            // formBind: {
            //   labelWidth: 120
            // },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".pdf",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  console.log(file);
                  let data = {
                    file: file,
                    filename: file.name,
                  };
                  // file["filename"] = file.name;
                  let that = this.$refs["table"].getModal("upload");
                  let isExist = false;
                  let isUpload = false;
                  if (that.list.length) {
                    that.list.forEach((item) => {
                      if (item.filename === file.name) {
                        that.$Message["error"]({
                          background: true,
                          content: "文件已存在",
                        });
                        isExist = true;
                        return false;
                      }
                      if (item.code !== undefined) {
                        isUpload = true;
                      }
                    });
                  }
                  if (isExist) return false;
                  if (isUpload) that.list = [];
                  that.list.push(data);

                  that.disabledConfirm = false;
                  return false;
                },
              },
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                name: () => "文件名称",
                key: "filename",
                align: "center",
                minWidth: 140,
              },
              {
                name: () => "上传状态",
                align: "center",
                key: "status",
                minWidth: 80,
                render(h, { row }) {
                  return h(
                    "span",
                    {
                      style: {
                        color:
                          row.code != undefined
                            ? row.code == 1
                              ? "red"
                              : "green"
                            : "blue",
                      },
                    },
                    row.code !== undefined
                      ? row.code == 1
                        ? "上传失败"
                        : "上传成功"
                      : "准备中"
                  );
                },
              },
              {
                name: () => "提示信息",
                align: "center",
                key: "msg",
                minWidth: 110,
              },
              // {
              //   name: () => this.$t("operate"),
              //   align: "center",
              //   key: "user",
              //   minWidth: 110
              // },
              // {
              //   name: () => this.$t("updateFile") + this.$t("date"),
              //   align: "center",
              //   key: "date",
              //   minWidth: 170
              // },
              {
                name: () => this.$t("operation"),
                align: "center",
                width: 60,
                render(h, { index }) {
                  return h("Icon", {
                    style: {
                      cursor: "pointer",
                    },
                    props: { type: "md-trash" },
                    on: {
                      click: () => {
                        this.list.splice(index, 1);
                      },
                    },
                  });
                },
              },
            ],
          },
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600,
            },
          },
          footer: { show: () => false },
        },
        orderDetail: {
          contentSlot: "ORDERDETAIL",
          config: {
            listFn: "list",
            modalBind: {
              width: "80%",
            },
          },
          footer: {
            show: false,
          },
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "clientId",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "serviceId",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
					
          {
            key: "salesmanId",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "to_country",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            options: [],
            config: { label: "code", value: "code" },
          },
					{
					  key: "is_out",
					  component: "Select",
					  bind: {
					    style: "width:150px",
					  },
					  placeholder() {
					    return this.$t("select") + this.$t("Whether Outbound");
					  },
					  options: [
							{value:'YES',label:'YES'},
							{value:'NO',label:'NO'},
						],
						show:()=>this.type == 3 || this.type == 4
					},
          {
            key: "service_code",
            component: "Select",
            bind: {
              style: "width:150px",
            },
						show:()=>{
							return this.type != 3
						},
            placeholder:()=> {
              return this.$t("select") + this.$t("company"+(this.type == 3?'1':''));
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                field.options = await this.$sel.getData("NOON_SERVICE");
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
              // autosize: { minRows: 2, maxRows: 2 }
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("updateFile"),
              type: "import",
              fnName: "importFun",
              bind: {
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            importFun({ file, searchForm }) {
              this.getModal("upload").open(null, function () {
                this.setTitle(this.$t("updateFile"));
                this.disabledConfirm = true;
              });
              // let formData = new FormData();
              // formData.append("file", file);
              // formData.append("client_id", searchForm.client_id);
              // this.$page
              //   .handleRequestMethods("updateSheet", formData, true)
              //   .then(res => {
              //     this.$page.getList();
              //   });
              // return false;
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          fixed: "left",
          copy: true,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          align: "center",
          showOverflow: false,
          width: 150,
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods("getOrderDetails", row.airway_number)
                .then((res) => {
                  this.$page.getModal("orderDetail").open(
                    {
                      dataDetails: res.payload,
                    },
                    function () {
                      this.setTitle(row.airway_number);
                    }
                  );
                });
            },
          },
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("shipperRef"),
          key: "client_refer_code",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("company"+(this.type == 3?'1':'')),
          key: "service_code",
          align: "center",
          minWidth: 130,
					show:()=>{
						return this.type != 3
					},
        },
        {
          name: () => this.$t("clientName"),
          key: "customerAccount",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "serviceAccount",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("salesman"),
          key: "staffAccount",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => this.$t("store_name"),
          key: "store_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("picker"),
          key: "picker",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => this.$t("label_url"),
          key: "label_url",
          align: "center",
          minWidth: 110,
          render: (h, params) => {
            if (params.row.label_url) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },

                    on: {
                      click: () => {
                        window.open(params.row.label_url, "_blank");
                      },
                    },
                  },
                  "PreView"
                ),
              ]);
            } else {
              return h("span", [h("span", " - ")]);
            }
          },
        },
        {
          name: () => this.$t("order_pcs"+(this.type == 3 || this.type == 4?'1':'')),
          key: "quantity",
          align: "center",
          minWidth: 95,
        },
				{
				  name: () => this.$t("Total qyt"),
				  key: "goods_count",
				  align: "center",
				  minWidth: 95,
				},
				{
				  name: () => this.$t("carton_nums"),
				  key: "box_count",
				  align: "center",
				  minWidth: 95,
				},
				{
				  name: () => this.$t("WeightAfterUsingCarton"),
				  key: "box_weight",
				  align: "center",
				  minWidth: 95,
				},
				{
				  name: () => this.$t("VolumnAfterUsingCarton"),
				  key: "box_volume",
				  align: "center",
				  minWidth: 95,
				},
        {
          name: () => this.$t("claim_weight"),
          key: "claim_weight",
          align: "center",
          minWidth: 125,
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 120,
        },
      ],
    };
  },
};
</script>
